import React, { useContext, useState } from 'react';
import {
   Nav, Tab,
} from 'react-bootstrap';
import { NavItem, NavLink, TabsWrap } from '@/shared/components/Tabs';
import Pending from './Pending';
import Confirm from './Confirmed';
import Past from './Past';
import Awaiting from './Awaiting';
import { AuthContext } from '../../../../context/AuthContext';
import Rejected from './Rejected';



const Tabs = () => {
  const { agentId } = useContext(AuthContext);

  const [paymentRefresh, setPaymentRefresh] = useState(false);
    
  return (
    <>
      {/* Tabs */}
      <Tab.Container defaultActiveKey="2" style={{ marginTop: '500px' }}>
        <TabsWrap>
          
          <Nav className="nav-tabs">
            <NavItem>
              <NavLink eventKey="1">Confirmed</NavLink>
            </NavItem>
            <NavItem>
              <NavLink eventKey="2">Pending</NavLink>
            </NavItem>
            <NavItem>
              <NavLink eventKey="3">Past</NavLink>
            </NavItem>
            <NavItem>
              <NavLink eventKey="4">Awaiting</NavLink>
            </NavItem>
            <NavItem>
              <NavLink eventKey="5">Rejected Booking</NavLink>
            </NavItem>
          </Nav>
          <Tab.Content>
            <Tab.Pane eventKey="1">

              <Confirm agentId={agentId} paymentRefresh={paymentRefresh} />
            </Tab.Pane>
            <Tab.Pane eventKey="2">
              <Pending agentId={agentId} paymentRefresh={paymentRefresh} setPaymentRefresh={setPaymentRefresh} />
            </Tab.Pane>
            <Tab.Pane eventKey="3">
              <Past agentId={agentId} paymentRefresh={paymentRefresh} />
            </Tab.Pane>
            <Tab.Pane eventKey="4">
              <Awaiting agentId={agentId} paymentRefresh={paymentRefresh} setPaymentRefresh={setPaymentRefresh} />
            </Tab.Pane>
            <Tab.Pane eventKey="5">
              <Rejected agentId={agentId} paymentRefresh={paymentRefresh} />
            </Tab.Pane>
          </Tab.Content>
        </TabsWrap>
      </Tab.Container>

     
    </>
  );
};

export default Tabs;
